import { render, staticRenderFns } from "./package_admin.vue?vue&type=template&id=27b7b776&scoped=true&"
import script from "./package_admin.vue?vue&type=script&lang=js&"
export * from "./package_admin.vue?vue&type=script&lang=js&"
import style0 from "./package_admin.vue?vue&type=style&index=0&id=27b7b776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b7b776",
  null
  
)

export default component.exports